import { create } from 'zustand';
import { ApiUtils, ProductApi, type ProductWithCurrencies, RequestStrategyEnum } from '@shared/api';

interface UseProductsWithCurrenciesStore {
  loading: boolean;
  data: ProductWithCurrencies[];
  error: string | null;
  getProducts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useProductsWithCurrenciesStore = create<UseProductsWithCurrenciesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getProducts: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getProductsWithCurrencies(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
